export default {
  items: [
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: "icon-speedometer",
      badge: {
        variant: "primary",
        text: "HOME"
      }
    },
    {
      name: "Map Overview",
      url: "/base/Map",
      icon: "icon-map"
    },
    {
      title: true,
      name: "TECHNICAL STATISTICS",
      class: "",
      wrapper: {
        element: "",
        attributes: {}
      }
    },
    {
      name: "Active Backlog",
      url: "/base/ActiveBacklog",
      icon: "icon-layers"
    },
    {
      name: "Received Equipment",
      url: "/base/ReceivedEquipment",
      icon: "icon-chart"
    },
    {
      name: "Analytics By Model",
      url: "/base/AnalyticsByModel",
      icon: "icon-chart"
    },
    {
      name: "Regional Analytics",
      url: "/base/RegionalAnalytics",
      icon: "icon-chart"
    },
    {
      name: "Regional Analytics Finance", //showing only for Dave Barton?!
      url: "/base/SubDivisionFinancial",
      icon: "icon-chart"
    },
    {
      name: "Beyond Economical Repair",
      url: "/base/BeyondEconomicalRepair",
      icon: "icon-chart"
    },
    {
      name: "End Of Life",
      url: "/base/EndOfLife",
      icon: "icon-chart"
    },
    {
      name: "No Trouble Found",
      url: "/base/NoTroubleFound",
      icon: "icon-chart"
    },
    {
      name: "Under Warranty",
      url: "/base/UnderWarranty",
      icon: "icon-chart"
    },
    {
      name: "Turn Around Time",
      url: "/base/TurnAroundTime",
      icon: "icon-chart"
    },
    {
      name: "OEM Repair",
      url: "/base/OemRepair",
      icon: "icon-chart"
    },
    {
      title: true,
      name: "Summary report",
      class: "",
      wrapper: {
        element: "",
        attributes: {}
      }
    },
    {
      name: "Exchange Reports",
      url: "/base/ExchangeReports",
      icon: "icon-chart"
    },
    {
      name: "Technical Reports",
      url: "/base/TechnicalReports",
      icon: "icon-chart"
    },
    {
      name: "Financial Reports",
      url: "/base/FinancialReports",
      icon: "icon-wallet"
    },
    {
      name: "Proof Of Delivery",
      url: "/base/ProofOfDelivery",
      icon: "icon-pencil"
    },
    {
      title: true,
      name: "Account",
      class: "",
      wrapper: {
        element: "",
        attributes: {}
      }
    },
    {
      name: "Inbox",
      url: "/base/Inbox",
      icon: "icon-envelope"
    }

    // HINT: code and pages below work, should not be deleted
    // {
    //   title: true,
    //   name: "TOOLS",
    //   class: "",
    //   wrapper: {
    //     element: "",
    //     attributes: {}
    //   }
    // },
    // {
    //   name: "Repaired Inventory",
    //   url: "/base",
    //   icon: "icon-puzzle",
    //   children: [
    //     {
    //       name: "Add New Item",
    //       url: "/base/AddNewItem",
    //       icon: "icon-pencil"
    //     },
    //     {
    //       name: "Inventory Report",
    //       url: "/base/Inventory",
    //       icon: "icon-puzzle"
    //     }
    //   ]
    // }
  ]
};
